import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { 
  Box,
  useToast 
} from '@chakra-ui/react';
import { getWatchFilmData , updateWatchFilmData } from '../../../services/Films';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
import SubmitButton from '../../../CommonComponents/SubmitButton';
import { RjsfSubmitButton } from '../../../RJSFCommonSchemas';
import FormLoader from '../../../CommonComponents/FormLoader';
import { showErrorToast, showSuccessToast } from "../../../util/errorHandler";


const WatchFilm = () => {
  const { alias } = useParams();
  const [basicFieldData, setBasicFieldData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [quickSave, setQuickSave] = useState(false);
  const toast = useToast();


  const schema =  {
    "title": "Film Specification fields",
    "description": "",
    "type": "object",
    "properties": {
      "full_movie_link": {
        "type": "string",
        "title": "Full Movie link",
      }
    }
  }

  const uiSchema = {
    ...RjsfSubmitButton(isSubmitting),
      full_movie_link: { "ui:emptyValue": "" }
  };

  const formData = basicFieldData;

  // Fetch initial data
  useEffect(() => {
    const getWatchFilmInitialData = async () => {
      try {
        if (alias) {
          setIsLoading(true);
          const result = await getWatchFilmData(alias);
          if (result) {
            setBasicFieldData(result);
            setQuickSave(false);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
                showErrorToast(toast, "Failed to fetch film data");
      } finally {
        setIsLoading(false);
      }
    };

    getWatchFilmInitialData();
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async (basicFieldData) => {
    setIsSubmitting(true);
    try {
      if (alias) {
        const result = await updateWatchFilmData(alias, basicFieldData);

        if (result?.status === 200)
        {
          setQuickSave(prev => !prev);
  
                        showSuccessToast(toast, "Data updated successfully");
        }
      }
    } catch (error) {
      console.error('Error updating film data:', error);
            showErrorToast(toast, "Failed to update film data");
    }
    finally
    {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="1200px">
      {isLoading ? (
        <FormLoader />
      ) : (
        <Form schema={schema} uiSchema={uiSchema} formData={formData} validator={validator} onSubmit={(e) => handleSubmit(e.formData)}>
          <SubmitButton isLoading={isSubmitting} />
        </Form>
      )}
    </Box>
  );
};

export default WatchFilm;